import { put, takeEvery, takeLatest } from 'redux-saga/effects';

import { actions } from '../../utils/constants';
import { createTrainer, deleteTrainer, fetchTrainers } from '../../utils/common-functions';

function* fetchAllTrainers() {
    yield put({ type: actions.TRAINERS_FETCH_LOADING, payload: { loading: true } });
    try {
        const trainers = yield fetchTrainers();
        yield put({ type: actions.TRAINERS_FETCHED, payload: trainers.data });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Os trainers não puderam ser carregados. Tente recarregar a página' } });
    }
    yield put({ type: actions.TRAINERS_FETCH_LOADING, payload: { loading: false } });
}

function* addTrainer({ payload: user }) {
    try {
        const { userId, email, name, nickname } = user;
        yield createTrainer({ userId });
        const trainer = {
            userId,
            email,
            name,
            nickname,
            obsoleteName: nickname,
        };
        yield put({ type: actions.TRAINER_CREATED, payload: trainer });
    } catch (e) {
        if (e.response && e.response.status === 404) {
            yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Instrutor deve ser coach. Por favor, contacte o suporte.' } });
        } else {
            yield put({ type: actions.REQUEST_ERROR, payload: { message: 'As alterações não puderam ser salvas. Tente novamente' } });
        }
    }
}

function* removeTrainer({ payload }) {
    try {
        yield deleteTrainer(payload);
        yield put({ type: actions.TRAINER_DELETED, payload });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'As alterações não puderam ser salvas. Tente novamente' } });
    }
}

export default function* trainers() {
    yield takeLatest(actions.ASYNC_FETCH_ADMIN_DATA, fetchAllTrainers);
    yield takeLatest(actions.ASYNC_FETCH_TRAINERS, fetchAllTrainers);
    yield takeEvery(actions.ASYNC_CREATE_TRAINER, addTrainer);
    yield takeEvery(actions.ASYNC_DELETE_TRAINER, removeTrainer);
}



// WEBPACK FOOTER //
// ./src/components/trainers/trainers.saga.js